import React from 'react'

const Clear: React.FC = () => {
  return (
    <svg width="8" height="9" viewBox="0 0 8 9" xmlns="http://www.w3.org/2000/svg"><path d="M8 1.057 7.293.35 4 3.643.707.35 0 1.057 3.293 4.35 0 7.643l.707.707L4 5.057 7.293 8.35 8 7.643 4.707 4.35 8 1.057Z" fill="currentcolor"></path></svg>
  )
}

export default Clear